import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/downloadSchedulerGroupsDetails', request, null, {responseType: 'arraybuffer'})
}

export {get}
